import React, { useState, useRef, useEffect, useContext } from "react";
import { NavLink, useHistory } from "react-router-dom";
import "./WorngContest.scss";
import moment from "moment";
import { useTranslation } from "react-i18next";
import outof5 from "../../assets/home/tickimg.png";
import time from "../../assets/home/timetakenicon.png";
import atar_logo from "../../assets/home/atar_logo.png";
import ohno_icon from "../../assets/home/ohno_icon.png";
import hono_time from "../../assets/home/hono_time.png";
import { useSelector, useDispatch } from 'react-redux'
import { StarButton } from '../../components'
import { clearTrivia, triviaQuestionsById } from '../../store/TriviaRedux'
import { Config } from "../../common";

const WorngContestScreen = (props) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch()
  const token = useSelector((state) => state.auth.token)
  const questions = useSelector((state) => state.trivia.questions)
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0)
    if (questions && questions._id) {
      let params = { contestantId: `${questions._id}`, token }
      dispatch(triviaQuestionsById(params))
    }
  }, []);

  const homepage = () => {
    dispatch(clearTrivia())
    history.push("/");
  };

  const tryAgain = () => {
    dispatch(clearTrivia())
    history.push("/payment");
  };

  return (
    <>
      <div className="container-fluid home clearall">
        <NavLink
          to="">
          <img className="star_img" src={atar_logo} />
        </NavLink>

        <div className="success_sec">
          <img className="Success_img" src={'https://media1.giphy.com/media/vbn5GcdB22nzJjfNOq/giphy.gif?cid=790b76119ba953415a644bcc5633cc2b55834717d847cadd&rid=giphy.gif&ct=s'} />
          <h5> Ohh  <span>Noooo...</span></h5>
          <div className="Ohh_border"></div>
          <h6><img className="ohno_img" src={outof5} />  <span>{questions?.score} out of {questions?.attemptedQuestions}</span> Questions are correct.</h6>
          <h6><img className="ohno_img" src={time} />  <span>{Config.parseDuration(questions?.timeTaken)} </span> was your quiz time</h6>

          <div className="Ohh_border"></div>
          <h4><img className="ohno_img" src={ohno_icon} /> <span>Results will be announced on {moment.utc(questions?.trivia?.resultDate ? questions?.trivia?.resultDate : questions?.trivia?.endDate).format('Do MMM YYYY')} at {moment.utc(questions?.trivia?.resultDate ? questions?.trivia?.resultDate : questions?.trivia?.endDate).format('hh:mm A')}</span></h4>
          <h4><img className="ohno_img" src={hono_time} /> <span>Your result will be based on how quickly you’ve answered the questions</span></h4>
          {/* <p>Share results on Social Media</p>
          <div className="succes_img">

            <i className="fa fa-whatsapp fa-2x" aria-hidden="true"></i>
            <i className="fa fa-twitter-square fa-2x" aria-hidden="true"></i>
            <i
              className="fa fa-facebook-official  fa-2x"
              aria-hidden="true"
            ></i>
            <i className="fa fa-instagram  fa-2x" aria-hidden="true"></i>
            <i className="fa fa-linkedin-square  fa-2x" aria-hidden="true"></i>
          </div> */}
          <h4 onClick={() => {
            history.push(`/contesthistory/${questions?.orderId}`)
          }}><a >View Summary </a></h4>
          <div className="try_pag">
            <button onClick={homepage} className="try">
              {t("fourscreen.btn")}
            </button>
            <div className="Return_to">
              <StarButton background={'mainBg'} width="350px" title="Try Again" onClickAction={tryAgain} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WorngContestScreen
